// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__1yLpy","layout-content":"Layout_layout-content__3LW_0"};